/**
 * P-02b (D-26) — the one way a task's ENGAGEMENT is named on screen when the
 * task has no project (service contract / hour bank / לל"ח): "name · type".
 * The type label comes from `engagementDetail.types.*`. Pure (no React), so
 * lists, timers and pickers share the same text.
 */
export type EngagementLabelTranslate = (key: string) => string;

export const ENGAGEMENT_TYPE_ORDER = ['project', 'development', 'service_contract', 'hour_bank', 'service_without_contract'] as const;
export type EngagementTypeKey = (typeof ENGAGEMENT_TYPE_ORDER)[number];

/** Project / development engagements own a projects row and milestones. */
export function isProjectEngagementType(type: string | null | undefined): boolean {
  return type === 'project' || type === 'development';
}

/**
 * F1-2 — the type as a table row / list item shows it: "לל\"ח" only; the full
 * "לל\"ח (שירות ללא חוזה)" stays in headings and forms (engagementDetail.types).
 */
export function engagementTypeShort(type: string | null | undefined, t: EngagementLabelTranslate): string {
  if (!type) return '';
  return type === 'service_without_contract'
    ? t('engagementDetail.typeShortLll')
    : t(`engagementDetail.types.${type}`);
}

/** "name · type" — or just one of them, or '' when neither is known. */
export function engagementLabel(
  name: string | null | undefined,
  type: string | null | undefined,
  t: EngagementLabelTranslate,
): string {
  const typeLabel = engagementTypeShort(type, t);
  return [name || '', typeLabel].filter(Boolean).join(' · ');
}

/**
 * What a task shows in its "project" slot: the project's name when it has one,
 * else its engagement ("name · type"), else ''.
 */
export function taskContainerLabel(
  task: { project_name?: string | null; engagement_name?: string | null; engagement_type?: string | null },
  t: EngagementLabelTranslate,
): string {
  if (task.project_name) return task.project_name;
  return engagementLabel(task.engagement_name, task.engagement_type, t);
}
